import React from "react";

interface MetaAdsPaymentRequiredModalProps {
  isOpen: boolean;
  onConfirm?: () => void;
}

const MetaAdsPaymentRequiredModal: React.FC<
  MetaAdsPaymentRequiredModalProps
> = ({ isOpen, onConfirm }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/70 backdrop-blur-md">
      {/* Modal */}
      <div
        className="relative w-full mx-4 bg-[#0b0c0f] overflow-hidden"
        style={{
          maxWidth: "860px",
          borderRadius: "36px",
          padding: "56px 72px",
        }}
      >
        {/* 🔴 Red Glow */}
        <div
          className="absolute left-1/2 -translate-x-1/2 blur-3xl opacity-90"
          style={{
            top: "-130px",
            width: "1400px",
            height: "270px",
            background:
              "radial-gradient(50% 50% at 50% 50%, #B1121A 20%, rgba(177,18,26,0) 70%)",
          }}
        />

        {/* Content */}
        <div className="relative z-10">
          <h2
            className="text-white text-center"
            style={{
              fontSize: "32px",
              fontWeight: 600,
              lineHeight: "130%",
            }}
          >
            Payment Method Required
          </h2>

          <p
            className="text-white text-center mt-4 leading-relaxed max-w-[600px] mx-auto"
            style={{
              fontSize: "16px",
              lineHeight: "150%",
            }}
          >
            We noticed that your Meta ad account does not have a payment
            method set up. To run ad campaigns, you need to add a valid
            payment method.
          </p>

          {/* Instructions */}
          <div className="mt-8  pl-[60px] mx-auto text-white">
            <p
              className="mb-3 font-medium text-white"
              style={{ fontSize: "16px" }}
            >
              How to set it up:
            </p>

            <ol className="list-decimal pl-5 space-y-2  " style={{ fontSize: "16px" }}>
              <li>Go to your Facebook Ads Manager.</li>
              <li>
                Click <span className="text-white">Payment Settings</span> in
                the top menu.
              </li>
              <li>Add a valid credit/debit card or PayPal account.</li>
              <li>Once added, return here to continue creating your campaign.</li>
            </ol>

            <div className="flex items-start gap-2 mt-5 text-yellow-400">
              <span>⚠️</span>
              <p
                className="text-white"
                style={{ fontSize: "14px" }}
              >
                Without a payment method, your ads cannot be published or
                delivered.
              </p>
            </div>
          </div>

          {/* Divider */}
          <div className="h-px h-[1px] bg-white/10 my-10" />

          {/* Action */}
          <div className="flex justify-center">
            <button
              onClick={onConfirm}
              className="px-8 py-3 rounded-full bg-white text-[#020202] font-semibold  h-[48px] w-[142px] transition-all"
              style={{
                fontSize: "16px",
                fontWeight: 600,
              }}
            >
              I will fix it!
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MetaAdsPaymentRequiredModal;
